import React from 'react';

import StyledLogo from '../logo';

export default props => (
    <div className="row">
        <div className="col-6 offset-1">
            <StyledLogo />
        </div>
    </div>
);